import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import MissionSection from '../components/MissionSection';
import TechnologySection from '../components/TechnologySection';
import ClinicalValidationSection from '../components/ClinicalValidationSection';
import WorkflowSection from '../components/WorkflowSection';
import TherapeuticsSection from '../components/TherapeuticsSection';
import TeamSection from '../components/TeamSection';
import PartnersSection from '../components/PartnersSection';
import NewsBanner from '../components/NewsBanner';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white text-ninsun-text">
      <Navigation />
      <HeroSection />
      <MissionSection />
      <TechnologySection />
      <ClinicalValidationSection />
      <WorkflowSection />
      <TherapeuticsSection />
      <TeamSection />
      <PartnersSection />
      <section id="news">
        <NewsBanner />
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;